module.exports = __webpack_public_path__ + "static/media/202.fde19998.jpg";